import React from 'react'
import { ReactNode } from 'react'
import HomeActionCard from './HomeActionCard'

interface CardQuickGuideProps {
  title: string
  subtitle: string
  icon: ReactNode
  path?: string
  /** Abre o manual em nova aba; usado quando o anexo já foi carregado. */
  onClick?: () => void
  /** Legado: o card do mockup não tem ilustração. Aceito e ignorado. */
  image?: string
}

/** Card do guia rápido — variante roxa do card único da Home. */
export default function CardQuickGuide({
  title,
  subtitle,
  icon,
  path,
  onClick,
}: CardQuickGuideProps) {
  return (
    <HomeActionCard
      icon={icon}
      title={title}
      description={subtitle}
      path={path}
      onClick={onClick}
      variant="brand"
    />
  )
}
